export default "__VITE_ASSET__xMZAQdVL__"